import { useState } from 'react';
import { toast } from 'react-toastify';

import { apiAuthServices } from 'services/api/auth';
import { apiUserServices } from 'services/api/user';
import { intlMessages } from 'services/util/auxiliaryUtils';

const useRecoveryPassword = () => {
    const [isRequesting, setIsRequesting] = useState(false);
    const [isRequestingRedefinePwd, setIsRequestingRedefinePwd] = useState(false);
    // The translation id of the message shown once the reset was asked for.
    const [msgResetPassword, setMsgResetPassword] = useState<string | null>(null);

    const fetchResetPassword = async (email: string) => {
        setMsgResetPassword(null);
        setIsRequesting(true);
        try {
            await apiAuthServices.requestPasswordReset(email);
            setMsgResetPassword('page.resetPwd.confirmYourEmail');
        } catch {
            // Already reported by the service.
            toast.error(intlMessages('label.error'));
        } finally {
            setIsRequesting(false);
        }
    };

    const fetchRedefinePassword = async (userSignOut: () => void, userID: number, password: string, onCloseDialog: () => void) => {
        setIsRequestingRedefinePwd(true);
        try {
            await apiUserServices.updatePassword(userID, password);
        } catch {
            // Already reported by the service.
            toast.error(intlMessages('label.error'));
            setIsRequestingRedefinePwd(false);
            return;
        }

        localStorage.removeItem('userToken');
        toast.success(intlMessages('label.changeWasSuccessful'));
        userSignOut();
        onCloseDialog();
        setIsRequestingRedefinePwd(false);
    };

    return {
        fetchResetPassword,
        isRequesting,
        isRequestingRedefinePwd,
        fetchRedefinePassword,
        msgResetPassword,
    };
};

export default useRecoveryPassword;
